/* eslint-disable indent */
function tryDecode(str = '') {
	try {
		return decodeURIComponent(str);
	} catch (e) {
		return str;
	}
}

function tryEncode(str = '') {
	try {
		return encodeURIComponent(str);
	} catch (e) {
		return str;
	}
}

function isEncoded(uri = '') {
	try {
		return uri !== decodeURIComponent(uri);
	} catch (e) {
		return false;
	}
}

export const getUrlParam = (name = '', search = window.location.search) => {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	let results = regex.exec(search);
	return results === null ? '' : tryDecode(results[1].replace(/\+/g, ' '));
};

export const getStrParam = (name, str) => {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	let results = regex.exec(str);
	return results === null ? '' : tryDecode(results[1].replace(/\+/g, ' '));
};

export const getCookie = cookieKey => {
	for (let cookie of document.cookie.split('; ')) {
		let [key, val] = cookie.split('=');
		if (cookieKey === key) {
			return tryDecode(val);
		}
	}
};

function rootDomain() {
	const parts = window.location.hostname.split('.');
	if (parts.length <= 2) {
		return window.location.hostname;
	}

	const sliced = parts.slice(-3);
	if (['co', 'com'].indexOf(sliced[1]) > -1) return sliced.join('.');

	return sliced.slice(-2).join('.');
}

export const setCookie = (name, value, days) => {
	let expires = '';
	if (days) {
		let date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = `; expires=${date.toUTCString()}`;
	}
	const secure = document.location.protocol === 'https:' ? '; Secure' : '';
	const cookie = `${name}=${
		value || ''
	}${expires};domain=.${rootDomain()};path=/${secure};`;
	document.cookie = cookie;
};

function isValidSource(str = '') {
	return /^((http|https):\/\/)/.test(str);
}

export function appendStyle(url) {
	if (!isValidSource(url)) {
		return;
	}

	if (document.querySelector(`link[href="${url}"]`)) {
		return;
	}

	const style = document.createElement('link');
	style.type = 'text/css';
	style.rel = 'stylesheet';
	style.href = url;

	document.head.appendChild(style);
}

export function appendScript(url = '', { onLoad } = {}) {
	if (!isValidSource(url)) {
		return;
	}

	if (document.querySelector(`script[src="${url}"]`)) {
		return;
	}

	const script = document.createElement('script');
	script.src = url;
	script.type = 'text/javascript';
	script.setAttribute('data-testid', 'custom-script');
	document.head.appendChild(script);

	if (typeof onLoad === 'function') {
		let done = false;
		script.onload = script.onreadystatechange = () => {
			if (
				!done &&
				(!script.readyState ||
					script.readyState === 'loaded' ||
					script.readyState === 'complete')
			) {
				done = true;
				try {
					onLoad();
				} catch (e) {}
			}
		};
	}
}

export const debounce = (fn, delay) => {
	let timerId;
	return function (...args) {
		if (timerId) {
			clearTimeout(timerId);
		}
		timerId = setTimeout(() => {
			fn(...args);
			timerId = null;
		}, delay);
	};
};

export const throttle = (fn, delay) => {
	let lastCall = 0;
	return function (...args) {
		const now = new Date().getTime();
		if (now - lastCall < delay) {
			return;
		}
		lastCall = now;
		return fn(...args);
	};
};

export const addClass = (elements, className) => {
	for (var i = 0; i < elements.length; i++) {
		var element = elements[i];
		if (element.classList) {
			element.classList.add(className);
		} else {
			element.className += ' ' + className;
		}
	}
};
export const removeClass = (elements, className) => {
	for (var i = 0; i < elements.length; i++) {
		var element = elements[i];
		if (element.classList) {
			element.classList.remove(className);
		} else {
			element.className = element.className.replace(
				new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'),
				' '
			);
		}
	}
};
export const hasClass = (element, className) => {
	if (element.classList) {
		return element.classList.contains(className);
	} else {
		return new RegExp('(\\s|^)' + className + '(\\s|$)').test(element.className);
	}
};

export const loadFonts = (fonts = [], fontsDomain) => {
	if (typeof fonts === 'string') {
		fonts = [].concat(fonts);
	}
	let fontsShouldLoad = fonts.filter(f => f && !isFontLoaded(f));
	if (fontsShouldLoad.length) {
		// appendStyle(`https://fonts.googleapis.com/css?family=${fontsShouldLoad.map(f => f.replace(/ /g, '+')).join('|')}`,doc);
		appendStyle(
			`https://${fontsDomain}/css?family=${fontsShouldLoad
				.map(f => f.replace(/ /g, '+'))
				.join('|')}`
		);
	}
	return fontsShouldLoad;
};

export const isFontLoaded = font => {
	const node = document.createElement('span');
	node.innerHTML = 'giItT1WQy@!-/#';
	node.style.position = 'absolute';
	node.style.left = '-10000px';
	node.style.top = '-10000px';
	node.style.fontSize = '300px'; // Large font size makes even subtle changes obvious
	node.style.fontFamily = 'sans-serif';
	node.style.fontVariant = 'normal';
	node.style.fontStyle = 'normal';
	node.style.fontWeight = 'normal';
	node.style.letterSpacing = '0';

	document.body.appendChild(node);

	// Remember width with no applied web font
	const width = node.offsetWidth;

	node.style.fontFamily = font + ', sans-serif'; //add fallback font

	const widthAfterFont = node.offsetWidth;

	node.parentNode.removeChild(node);

	return widthAfterFont !== width;
};

export const objectToFormData = (formData, obj, previousKey) => {
	if (obj instanceof Object) {
		Object.keys(obj).forEach(key => {
			const value = obj[key];
			if (value instanceof Object && !isArray(value)) {
				return objectToFormData(formData, value, key);
			}
			if (previousKey) {
				key = `${previousKey}[${key}]`;
			}
			if (isArray(value)) {
				value.forEach((val, i) => {
					return objectToFormData(formData, val, `${key}[${i}]`);
				});
			} else {
				formData.append(key, value);
			}
		});
		return formData;
	}
};

export const serialize = (obj, prefix) => {
	var str = [],
		p;
	for (p in obj) {
		if (obj.hasOwnProperty(p)) {
			var k = prefix ? prefix + '[' + p + ']' : p,
				v = obj[p];
			str.push(
				v !== null && typeof v === 'object'
					? serialize(v, k)
					: encodeURIComponent(k) + '=' + encodeURIComponent(v)
			);
		}
	}
	return str.join('&');
};

export const triggerEvent = data => {
	let element = data.element || document;
	if (typeof CustomEvent === 'function') {
		let e = new CustomEvent('mopinion_' + data.event, {
			bubbles: false,
			detail: data
		});
		element.dispatchEvent(e);
	} else {
		let e = document.createEvent('CustomEvent');
		e.initCustomEvent('mopinion_' + data.event, false, false, data);
		element.dispatchEvent(e);
	}
};

export const encodeQuotes = text => {
	let map = {
		'"': '&quot;',
		"'": '&#039;'
	};
	return text.replace(/["']/g, m => {
		return map[m];
	});
};

export const prependChild = (parentElement, newElement) => {
	return parentElement.insertBefore(newElement, parentElement.firstChild);
};

export const isArray = t => {
	if (Array.isArray) {
		return Array.isArray(t);
	} else {
		return t instanceof Array;
	}
};

export const nodeListToArray = list => {
	return Array.prototype.slice.call(list);
};

export function anonymizeValue(target) {
	const value = target.value || target.getAttribute('value');
	if (value) {
		const replacedValue = value.replace(/./g, '*');
		target.setAttribute('value', replacedValue);
		target.value = replacedValue;
	}
	return target;
}

export function rnd() {
	return Math.random().toString(36);
}

export function shuffleArray(array, keepLastIndex) {
	return array
		.map((a, index) => {
			return {
				sort: keepLastIndex && index === array.length - 1 ? 1 : Math.random(),
				value: a
			};
		})
		.sort((a, b) => a.sort - b.sort)
		.map(a => a.value);
}

export function createRandomId(len = 35, bits = 36) {
	let outStr = '',
		newStr;
	while (outStr.length < len) {
		newStr = Math.random().toString(bits).slice(2);
		outStr += newStr.slice(0, Math.min(newStr.length, len - outStr.length));
	}
	return outStr;
}

export function createId(len) {
	const time = new Date().getTime();
	return `${time}${createRandomId(len)}`;
}

export function stripTags(str = '') {
	return String(str).replace(/(<([^>]+)>)/gi, '');
}

export function getMetaData(webView = false) {
	const metaData = webView ? window.metaData : window.__mopinionMetaData;

	return Object.keys(metaData ?? {}).map(metaDataKey => {
		return {
			label: metaDataKey,
			value: metaData[metaDataKey],
			type: 'category'
		};
	});
}

export function startsWith(startStr, fullStr) {
	return fullStr.substr(0, startStr.length) === startStr;
}

export function getImageUri(uri) {
	if (startsWith('data:image', uri)) {
		return uri;
	}
	return `https://cacheorcheck.mopinion.com/survey/public/image?file=${uri}`;
}

export function _get(value, path, defaultValue, ignoreWindow = true) {
	return String(path)
		.replace(/\["|\['|\[/g, '.')
		.replace(/"]|']|]/g, '')
		.split('.')
		.reduce((acc, current, index, currentArr) => {
			if (index === 0 && current === 'window' && ignoreWindow) {
				return acc;
			}

			try {
				const key = current.replace(/[()]/g, ''); //handle possible functions

				const wildcard = key === '*';
				const lastWildcard = key === '*LAST';

				if ((wildcard || lastWildcard) && Array.isArray(acc)) {
					const nextSearchKey = currentArr[index + 1];
					acc = acc.filter(item => {
						return item?.[nextSearchKey];
					});

					return wildcard ? acc[0] ?? defaultValue : acc.pop() ?? defaultValue;
				} else {
					acc = typeof acc[key] === 'function' ? acc[key]() : acc[key];
					return acc ?? defaultValue;
				}
			} catch (e) {
				return defaultValue;
			}
		}, value);
}

export function getJsFromString(str) {
	try {
		return _get(window, str, undefined);
	} catch (e) {
		return undefined;
	}
}

export function removeEmptyFromNestedObject(obj) {
	const newObj = {};

	Object.keys(obj).forEach(key => {
		if (obj[key] && typeof obj[key] === 'object') {
			newObj[key] = removeEmptyFromNestedObject(obj[key]); // recurse
		} else if (obj[key] !== null) {
			newObj[key] = obj[key]; // copy value
		}
	});

	return newObj;
}

export function isUuid(id) {
	return isNaN(Number(id));
}

export function getTextContent(sel, divName, multipleIndex) {
	let selector;

	try {
		selector = findSelector(sel, divName, multipleIndex);
	} catch (e) {}

	if (selector) {
		if (selector.nodeName === 'INPUT') {
			return selector.value;
		} else {
			return selector.textContent;
		}
	}

	return '';
}

export function mapBrFromString(str, requiredMarkLabel) {
	if (typeof str !== 'string') return str;

	if (str.split('<br/>').length === 1 && str.split('<br>').length === 1) return str;

	//<br/> is used in classic, <br> is used in raspberry
	var br = str.split('<br/>').length > 1 ? '<br/>' : '<br>';

	if (requiredMarkLabel) {
		return str.split(br).map((item, index) => {
			return index === str.split(br).length - 1 ? (
				<span>
					{item}
					<span
						aria-label={requiredMarkLabel}
						class="required-mark"
					>
						*
					</span>
					<br />
				</span>
			) : (
				<span>
					{item}
					<br />
				</span>
			);
		});
	} else {
		return str.split(br).map(item => {
			return (
				<span>
					{item}
					<br />
				</span>
			);
		});
	}
}

export function getDataAttr(sel, divName, multipleIndex) {
	let selector;
	let cleanSel = sel.replace(/{{FORM_DIV}}\s/, '');
	let selObj = cleanSel.split(' ');

	try {
		selector = findSelector(sel, divName, multipleIndex);
	} catch (e) {}

	if (selector) {
		let selAttr =
			selObj.length > 1
				? selObj[1].replace(/\[|\]/gi, '')
				: cleanSel.replace(/\[|\]/gi, '');
		return selector.getAttribute(selAttr) || '';
	}

	return '';
}

export function findSelector(sel, divName, multipleIndex) {
	const selectorArray = sel.split('{{FORM_DIV}}');

	if (sel.match('{{FORM_DIV}}') !== null && selectorArray.length > 1) {
		//trim selector for excess whitespace
		const selector = selectorArray[1].trim();
		const [baseDiv, ...rest] = selector.split(' ');

		// make sure only one selector is passed to querySelectorAll.
		// if multiple classes exist, we don't to chain them all, added extra classes might be too generic.

		//const selectedDiv = divName.split(' ')[0];
		const selectedDiv =
			divName instanceof HTMLElement && divName.className.length
				? `.${divName.className.split(' ')[0]}`
				: divName instanceof HTMLElement && divName.id.length
				? `#${divName.id}`
				: '';

		return rest.length > 0
			? document
					.querySelectorAll(selectedDiv)
					[multipleIndex].closest(baseDiv)
					.querySelector(rest.join(' '))
			: document.querySelectorAll(selectedDiv)[multipleIndex].closest(baseDiv);
	}

	return document.querySelector(sel);
}

export function isLandingPage() {
	return (
		document.location.pathname.indexOf('/survey/public/take-survey/') > -1 ||
		document.location.pathname.indexOf('/survey/public/email-survey/') > -1
	);
}

//TODO: initialize form with isPreview prop
export function isPreviewPage() {
	return (
		document.location.pathname.indexOf('/survey/manage/preview/') > -1 ||
		document.location.pathname.indexOf('/data-collection/survey/preview/') > -1 ||
		document.location.pathname.indexOf('/data-collection/survey/edit/') > -1 ||
		document.location.pathname.indexOf('/survey/public/preview/') > -1 ||
		(document.location.href.indexOf('blank') > -1 &&
			window.parent.window.origin.indexOf('.mopinion.com') > -1)
	);
}

export function getPageUrl() {
	const value = document.querySelector('#public-survey-page-querystring')?.value ?? '';
	return isLandingPage() ? `${document.location.href}${value}` : document.location.href;
}

export function getPageSearch() {
	return isLandingPage()
		? document.querySelector('#public-survey-page-querystring')?.value ?? ''
		: document.location.search;
}

export function tryFocus(el, timeout, exception = () => {}) {
	const focusFn = () => {
		try {
			el.focus();
		} catch (e) {
			exception();
		}
	};

	if (timeout) {
		return setTimeout(() => focusFn(), timeout);
	}

	return focusFn();
}

export function getNonce(type) {
	if (type === 'style') {
		if (window._MOPINION_NONCE) {
			return window._MOPINION_NONCE;
		}

		if (document.querySelector('[data-style-nonce]')?.getAttribute('data-style-nonce')) {
			return document
				.querySelector('[data-style-nonce]')
				.getAttribute('data-style-nonce');
		}

		if (document.querySelector('style[nonce]')?.nonce) {
			return document.querySelector('style[nonce]').nonce;
		}
	}

	if (type === 'script') {
		if (
			document.querySelector('[data-script-nonce]')?.getAttribute('data-script-nonce')
		) {
			return document
				.querySelector('[data-script-nonce]')
				.getAttribute('data-script-nonce');
		}

		if (document.querySelector('script[nonce]')?.nonce) {
			return document.querySelector('script[nonce]').nonce;
		}
	}

	return document.querySelector('[nonce]')?.nonce;
}

export function rectIsHidden(rect) {
	if (!rect) {
		return true;
	}

	return (
		rect?.width === 0 &&
		rect?.height === 0 &&
		rect?.top === 0 &&
		rect?.bottom === 0 &&
		rect?.left === 0 &&
		rect?.right === 0 &&
		rect?.x === 0 &&
		rect?.y === 0
	);
}

//make className string from array
export function makeClassName(...args) {
	const prefix = str => 'mop-' + str;

	return args
		.reduce((classNameString, current) => {
			if (typeof current === 'string' && current.length > 0) {
				classNameString.push(prefix(current));
			}

			if (isArray(current)) {
				classNameString.push(current.map(str => prefix(str)).join(' '));
			}

			if (current?.prefix === false && current?.className) {
				classNameString.push(current.className);
			}

			return classNameString;
		}, [])
		.join(' ');
}

export function scrollEmbeddedIntoView(el) {
	try {
		const y = el.getBoundingClientRect().top + window.pageYOffset + -150;
		window.scrollTo({ top: y, behavior: 'smooth' });
	} catch (e) {}
}

export function setLangAttribute(locale = '') {
	try {
		const langCode = locale.split('_')[0];
		document.documentElement.setAttribute('lang', langCode);
	} catch (e) {}
}

export function stringify(obj = {}) {
	const cache = [];
	try {
		return JSON.stringify(
			obj,
			//ignore circular references in object
			(key, value) => {
				if (typeof value === 'object' && value !== null) {
					if (cache.indexOf(value) !== -1) {
						// Circular reference found, discard key
						return;
					}
					// Store value in our collection
					cache.push(value);
				}
				return value;
			}
		);
	} catch (e) {
		return '';
	}
}

export function getWebsiteDataName({ block = {}, type = '', index = 0 }) {
	return `${block.typeName}_${type}_${block.id}_${index + 1}`.replace(/\W/g, '');
}

export function getWebsiteDataValue({ type, value, divName, multipleIndex } = {}) {
	const getData = () => {
		switch (type) {
			case 'data_attr':
				return getDataAttr(value, divName, multipleIndex);

			case 'css_selector':
				return getTextContent(value, divName, multipleIndex);

			case 'js':
				const jsValue = getJsFromString(value);
				if (typeof jsValue !== 'string') {
					try {
						return stringify(jsValue);
					} catch (e) {}
				}

				return jsValue;

			case 'cookie':
				return getCookie(value);

			case 'url_parameter':
				const param = isEncoded(value) ? value : tryEncode(value);
				return getUrlParam(param, getPageSearch());

			default:
				return '';
		}
	};

	const foundData = getData();

	return typeof foundData === 'string' ? foundData : '';
}

export function getStorage(key) {
	try {
		const obj = JSON.parse(sessionStorage.getItem(key));
		const isExpired = new Date().getTime() > Number(obj.time);

		if (isExpired) {
			return undefined;
		}

		return obj.value;
	} catch (e) {
		return undefined;
	}
}

export function setStorage(key, value) {
	try {
		sessionStorage.setItem(
			key,
			JSON.stringify({
				time: new Date().getTime() + 60000 * 10, //expires in 10 minutes
				value
			})
		);
	} catch (e) {}
}

export function removeStorage(key) {
	try {
		sessionStorage.removeItem(key);
	} catch (e) {}
}

export function range(start = 1, end = 10, arr = []) {
	let c = end - start + 1;
	while (c--) {
		arr[c] = end--;
	}
	return arr;
}

/**
 * Parses field to blockId, extra1 (element key), extra2 ()
 * @param {string} field
 * @returns {Array} blockId, extra1, extra2
 */
export function getIdFromField(field = '') {
	return field
		.replace(/([^1-9]+)/, '') //remove everything before first number
		.split('_');
}

export function getDatafieldIdFromExtra({ block = {}, extra1 = '', extra2 }) {
	if (extra1 === 'extra' && extra2) {
		return block.properties?.elements_extra?.[extra2]?.data_field;
	}
	if (extra1 === 'name' && !block.properties?.elements?.name?.combine) {
		return block.properties?.elements?.name?.subelements?.lastname?.data_field;
	}
	if (extra1 === 'firstname') {
		return block.properties?.elements?.name?.subelements?.firstname?.data_field;
	}

	return block.properties?.elements?.[extra1]?.data_field;
}

export function log() {
	const DEBUG = getCookie('MopinionDebug') == 1;
	if (DEBUG) {
		console.log(...arguments);
	}
}

export function supportsCSSStyleSheetReplace() {
	try {
		const sheet = new CSSStyleSheet();
		return typeof sheet.replaceSync === 'function';
	} catch (e) {
		return false;
	}
}

export function determineBot() {
	const isWebdriverEnabled = window.navigator.webdriver === true;
	const hasNoLanguages =
		!Array.isArray(window.navigator.languages) || window.navigator.languages.length === 0;
	const documentIsNotVisible = document.visibilityState !== 'visible';
	const hasSuspiciousUserAgent =
		/HeadlessChrome|puppeteer|phantomjs|selenium|curl|python/i.test(
			window.navigator.userAgent || ''
		);
	const hasMicrosoftCrawler = /Microsoft Office|SafeLinks|Microsoft-WebDAV/i.test(
		window.navigator.userAgent || ''
	);
	const hasZeroWidth = window.screen.width === 0 || window.innerWidth === 0;

	const isLikelyBot = [
		isWebdriverEnabled && 'webdriver',
		hasNoLanguages && 'no languages',
		documentIsNotVisible && 'document not visible',
		hasSuspiciousUserAgent && 'suspicious user agent',
		hasMicrosoftCrawler && 'microsoft crawler',
		hasZeroWidth && 'zero width'
	].filter(Boolean);

	return {
		isBot: isLikelyBot.length > 0,
		reason: isLikelyBot.join(', ')
	};
}
